import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './About.module.css';
import storyImg from '../../assets/New-Images/img15.jpg';
// import ownerImg from '../../assets/New-Images/img30.jpg';


const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const values = [
    { icon: '🤝', title: 'Honest', gujarati: 'પ્રામાણિક', desc: 'Transparent in every step' },
    { icon: '🌿', title: 'Organic', gujarati: 'કુદરતી', desc: 'Pure and natural products' },
    { icon: '🏛️', title: 'Traditional', gujarati: 'પરંપરાગત', desc: 'Ancient Vedic methods' },
    { icon: '💚', title: 'Trust', gujarati: 'વિશ્વાસ', desc: 'Building lasting relationships' },
  ];

  const gallery = [
    { image: '🐄', title: 'Our Gir Cows', desc: 'Healthy and happy' },
    { image: '🌾', title: 'Green Pastures', desc: 'Organic grazing land' },
    { image: '🛕', title: 'Farm Temple', desc: 'Blessed with tradition' },
    { image: '👨‍🌾', title: 'Our Team', desc: 'Dedicated workers' },
    { image: '🏡', title: 'Farm House', desc: 'Traditional setup' },
    { image: '🌅', title: 'Morning Rituals', desc: 'Starting with prayers' },
  ];

  return (
    <div className={styles.about}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>About Bahariya Farm</h1>
          <p className="gujarati-text">બાહરીયા ફાર્મ વિશે</p>
          <p className={styles.subtitle}>Preserving Tradition, Delivering Purity</p>
        </div>
      </section>

      <section className={`${styles.storySection} texture-bg`}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className={styles.sectionTitle}>Our Story</h2>
            <p className={`${styles.sectionSubtitle} gujarati-text`}>અમારી વાર્તા</p>

            <div className={styles.storyContent}>
              <div className={styles.storyText}>
                <p>
                  Bahariya Farm was born from a deep respect for our ancient traditions and
                  a commitment to providing families with the purest, most nutritious ghee.
                  Located in the heart of Gujarat, our farm is home to indigenous Gir cows
                  that graze freely on organic pastures.
                </p>
                <p className="gujarati-text">
                  બાહરીયા ફાર્મ અમારી પ્રાચીન પરંપરાઓ પ્રત્યેના ઊંડા આદર અને પરિવારોને
                  શુદ્ધતમ, સૌથી પોષક ઘી પ્રદાન કરવાની પ્રતિબદ્ધતાથી જન્મ્યું છે.
                </p>
                <p>
                  We follow the traditional Bilona method, passed down through generations,
                  where every step is done with care and devotion. From hand-milking our cows
                  to hand-churning the curd, we ensure that the ancient wisdom is preserved
                  in every jar of ghee we produce.
                </p>
                <p>
                  Our mission is simple: to bring back the authentic taste and health benefits
                  of pure Gir cow ghee to modern families, while supporting sustainable farming
                  and cow welfare.
                </p>
              </div>

              <div className={styles.storyImage}>
                <div className={styles.storyImgWrapper}>
                  <img src={storyImg} alt="Bahariya Farm Story" className={styles.storyImg} />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section className={styles.valuesSection}>
        <div className="container">
          <h2 className={styles.sectionTitle}>Our Values</h2>
          <p className={`${styles.sectionSubtitle} gujarati-text`}>અમારા મૂલ્યો</p>

          <div className={styles.valuesGrid}>
            {values.map((value, index) => (
              <motion.div
                key={index}
                className={styles.valueCard}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className={styles.valueIcon}>{value.icon}</div>
                <h3>{value.title}</h3>
                <p className={`${styles.valueGujarati} gujarati-text`}>{value.gujarati}</p>
                <p className={styles.valueDesc}>{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className={`${styles.ownerSection} texture-bg`}>
        <div className="container">
          <div className={styles.ownerContent}>
            <div className={styles.ownerMessage}>
              <h2>Message from Bahariya Farm</h2>
              <blockquote>
                "Every jar of ghee we produce is a promise of purity. We treat our cows
                like family and follow the methods our ancestors taught us. When you choose
                Bahariya Farm, you're not just buying ghee – you're becoming part of our
                family and supporting a tradition that has nourished generations."
              </blockquote>
            </div>
          </div>
        </div>
      </section>
      {/* 
      <section className={styles.gallerySection}>
        <div className="container">
          <h2 className={styles.sectionTitle}>Farm Gallery</h2>
          <p className={`${styles.sectionSubtitle} gujarati-text`}>ફાર્મ ગેલેરી</p>

          <div className={styles.galleryGrid}>
            {gallery.map((item, index) => (
              <motion.div
                key={index}
                className={styles.galleryCard}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.05 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className={styles.galleryImage}>{item.image}</div>
                <div className={styles.galleryInfo}>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;
